/* eslint-disable import/no-cycle */
import React from "react";
import { SvgProps } from ".";

export const Email: React.FC<SvgProps> = ({ fill, height, width }) => (
  <svg
    aria-labelledby="email-svg"
    height={height || "35px"}
    viewBox="0 0 35 35"
    version="1.1"
    width={width || "35px"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="email-svg">Email</title>
    <defs>
      <filter colorInterpolationFilters="auto" id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      id="Resource-Center"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Important-links-sidebar"
        transform="translate(-1216.000000, -450.000000)"
      >
        <g id="Group-4" transform="translate(1036.000000, 410.000000)">
          <g id="icons" transform="translate(1.000000, 40.000000)">
            <g id="email" transform="translate(179.000000, 0.000000)">
              <circle
                id="Oval"
                fill={fill || "#252525"}
                cx="17.5"
                cy="17.5"
                r="17.5"
              />
              <g filter="url(#filter-1)" id="Icons/Email-Copy">
                <g transform="translate(5.000000, 5.000000)">
                  <path
                    d="M22.6641129,19.7960046 C22.1887277,20.2542199 21.5541784,20.5494588 20.8658083,20.5623203 C15.289321,20.5968736 9.71225913,20.5968736 4.13577184,20.5623203 C2.75539252,20.5364053 1.51444932,19.3375972 1.48782622,17.9084337 C1.46484224,14.3029872 1.46484224,10.6971568 1.48782622,7.09171026 C1.51349166,5.70727408 2.70942457,4.46431454 4.13577184,4.43782366 C9.71225913,4.40307839 15.289321,4.40307839 20.8658083,4.43782366 C22.251359,4.46354669 23.4871308,5.66197085 23.5137539,7.09171026 C23.534631,10.6971568 23.534631,14.3027952 23.5137539,17.9082418 C23.5037942,18.4417065 23.3210716,18.9532876 23.0188323,19.3825165 C23.0310904,19.4842569 22.9757373,19.5633456 22.9184689,19.6403227 C22.8541138,19.726706 22.7635186,19.7827591 22.6641129,19.7960046 Z M15.2309034,12.794735 L14.7999539,13.2116783 C13.5193633,14.4360175 11.3460368,14.4882314 10.0110508,13.2103346 L9.91700805,13.1191522 L3.11126109,19.4552705 C3.40890358,19.6614386 3.76438909,19.7873662 4.1453485,19.7944689 C9.71551519,19.8290222 15.286065,19.8290222 20.8562317,19.7944689 C21.279903,19.7865984 21.6857617,19.6265013 22.0121341,19.3638961 L15.2309034,12.794735 Z M2.61001887,6.04071358 C2.39396949,6.34382294 2.26123703,6.70932023 2.25395877,7.1013084 C2.23097479,10.7004201 2.23097479,14.2997238 2.25395877,17.8988356 C2.26066243,18.2608775 2.37807224,18.6094821 2.57477677,18.9068326 L9.36539262,12.5847276 L2.61001887,6.04071358 Z M22.3136073,5.94127681 L15.7825188,12.2610782 L22.508588,18.7770657 C22.6547278,18.5148444 22.7416839,18.2161502 22.7476214,17.8988356 C22.7684985,14.2997238 22.7684985,10.7004201 22.7476214,7.10111644 C22.7397685,6.67476692 22.5771569,6.26799761 22.3136073,5.94127681 Z M21.7246429,5.44370907 C21.4633917,5.29800926 21.167473,5.21143401 20.8562317,5.20567512 C15.2943009,5.17092984 9.73237011,5.20548316 4.1702478,5.20548316 C3.81035704,5.20759475 3.46329899,5.31989302 3.1656565,5.51108804 C5.63183717,7.90217747 8.08595126,10.3057445 10.5672631,12.680901 C11.5659168,13.6126887 13.240108,13.6418671 14.2695986,12.6576735 L21.7246429,5.44370907 Z"
                    id="Fill-2"
                    stroke={fill || "#252525"}
                    strokeWidth="0.5"
                    fill={fill || "#252525"}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
